import { IApexCourse } from '../../../models/IApexCourse'
import { IAlertConfig } from '../../../models/bootstrap/Alert' 

export class MaintainCountryController {

    countries
    country

    countrySettings:any = {}
    financialDetails = {}
    apexCourses: IApexCourse[] = []

    alerts: IAlertConfig[] = []

    static $inject = ['$scope', '$q', 'Spinner', 'ApplicationLookup', 'CountrySettings', 'PaymentOptions', 'dialogs', '$uibModal','ApexCourses'];
    constructor(private $scope, private $q, private Spinner, private ApplicationLookup, private CountrySettings, private PaymentOptions, private dialogs, private $uibModal, private ApexCourses) {
        ApplicationLookup.country().$promise.then((data) => {
            this.countries = data;
        });  
    }

    countrySelected(newValue) {
        if (newValue) {
            this.CountrySettings.get({ countryCode: newValue.code }).$promise.then((data) => {
                this.countrySettings = data;
            });

            this.PaymentOptions.byCountry({ countryCode: newValue.code }).$promise.then((data) => {
                this.financialDetails = data;
            });

            this.loadApexCourses(newValue.code);
        }
    }

    loadApexCourses(countryCode) {
        this.ApexCourses.get({ countryCode: countryCode }).$promise.then((data) => {
            this.apexCourses = data;
        });
    }

    startEditing(apexCourse) {
        apexCourse.toUpdate = true;
    }

    addApexCourse() {
        var newApexCourse = { countryCode: this.countrySettings.countryCode, apexEducationCode: '',  description: '', isActive: true, isUsed: true, isNew: true, toUpdate: true, toDelete: false};
        this.apexCourses.push(newApexCourse);
    }

    saveApexCourse(index) {
        var courseToSave = this.apexCourses[index];
        this.ApexCourses.save({ countryCode: this.countrySettings.countryCode }, courseToSave)
            .$promise
            .then(() => {

                this.alerts.push({
                    type: 'success',
                    msg: 'save sucessfully',
                    dismissOnTimeout: 5000
                })
            });
    }

    saveAllApexCourseChange(index) {
        var courseToSave = this.apexCourses[index];
        this.ApexCourses.save({ countryCode: this.countrySettings.countryCode }, courseToSave)
            .$promise
            .then(() => {
                this.loadApexCourses(this.countrySettings.countryCode);

                this.alerts.push({
                    type: 'success',
                    msg: 'saved sucessfully',
                    dismissOnTimeout: 5000
                })
            });
    }

    removeApexCourse(index) {
        var courseTodelete = this.apexCourses[index];

        if (courseTodelete.isNew) {
            this.apexCourses.splice(index, 1);
            return;
        }
        else {
            //todo confirm delete

            this.ApexCourses.check_apex_qual_used({ countryCode: this.countrySettings.countryCode, apexEducationCode: courseTodelete.apexEducationCode })
                .$promise
                .then((result) => {
                    if (!result.isUsed) {
                        this.remove(index, courseTodelete);
                        return;
                    }
                });            
        }
    }

    remove(index, courseTodelete) {

        this.ApexCourses.remove({ countryCode: this.countrySettings.countryCode, apexEducationCode: courseTodelete.apexEducationCode })
            .$promise
            .then((result) => {

                this.apexCourses.splice(index, 1);

                this.alerts.push({
                    type: 'success',
                    msg: 'deleted sucessfully',
                    dismissOnTimeout: 5000
                })
            });  
    }

    save() {
        this.$scope.$broadcast('submitted', true)

        var promisses = []
        var form = this.$scope.maintainCountryForm
        if (form['CountryBasicDetails'].$dirty || form['CountryVisaDetails'].$dirty) {
            promisses.push(this.CountrySettings.save(this.countrySettings).$promise);
        }
        if (form['CountryFinancialDetails'].$dirty) {
            promisses.push(this.PaymentOptions.save(this.financialDetails).$promise);
        }


        var apexCoursesToInsertAndUpate = this.apexCourses.filter((r) => r.isNew || r.toUpdate);

        if (apexCoursesToInsertAndUpate && apexCoursesToInsertAndUpate.length>0) {
            promisses.push(this.ApexCourses.save({ countryCode: this.countrySettings.countryCode }, apexCoursesToInsertAndUpate)
                .$promise
                .then(() => {
                    this.loadApexCourses(this.countrySettings.countryCode);

                }));
        }

        this.$q.all(promisses)
            .then(() => {
                form.$setPristine()
                //TODO move this to parent class and remove saved flag
                this.alerts.push({ // TODO should I be able to display the same message twice?
                    type: 'success',
                    msg: 'Save complete',
                    dismissOnTimeout: 5000
                })
            }, () => {
                //TODO move this to parent class and remove saved flag
                this.alerts.push({ // TODO should I be able to display the same message twice?
                    type: 'danger',
                    msg: 'We are sorry but your form could not be saved. Please try again in 5 minutes. <br /> If this problem continues, please contact us at: <a target= "_blank" href= "mailto:support@aupairamerica.co.uk" > support@aupairamerica.co.uk</a>',
                    dismissOnTimeout: 20000
                })
            })


        //this.Spinner.show();

            

    }

        


    public closeAlert(index: number) {
        this.alerts.splice(index, 1)
    }
}


angular
    .module('app')
    .controller('MaintainCountryController', MaintainCountryController);
